import React from 'react';
import classNames from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TabsHeader = _ref => {
  let {
    headings,
    selectedTab,
    onTabHeadingClick,
    fullWidth = false,
    disabledTabVal,
    className
  } = _ref;
  const iconType = heading => {
    switch (heading) {
      case 'Nearby':
        return 'location-drop-pin';
      case 'All centres':
        return 'list-view';
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: classNames(fullWidth ? style.tabBarFull : style.tabBar, className),
    "data-id": "tabs-header-v2_index_TabsHeader_div",
    children: /*#__PURE__*/_jsx("ul", {
      id: "container",
      className: fullWidth ? style.tabHeaderFull : classNames(style.tabHeader),
      role: "tablist",
      "data-id": "tabs-header-v2_index_TabsHeader_div_ul",
      children: headings.map((heading, i) => {
        const isDisabled = disabledTabVal === heading;
        return /*#__PURE__*/_jsxs("li", {
          role: "presentation",
          "data-id": "tabs-header-v2_index_TabsHeader_li",
          children: [iconType(heading) && /*#__PURE__*/_jsx(Icon, {
            className: classNames(style.tabIcon, {
              [style.tabIconDisabled]: isDisabled
            }),
            type: iconType(heading),
            "data-id": "tabs-header-v2_index_TabsHeader_Icon"
          }), /*#__PURE__*/_jsx("button", {
            "data-test-id": "tab-button",
            disabled: isDisabled,
            className: classNames(fullWidth ? style.tabTitleFull : style.tabTitle, {
              [style.activeTabTitle]: selectedTab === i,
              [style.buttonDisabled]: isDisabled
            }),
            "aria-controls": "tabpanel".concat(i),
            "aria-selected": selectedTab === i,
            role: "tab",
            onClick: () => onTabHeadingClick(i),
            "data-id": "tabs-header-v2_index_TabsHeader_li_button",
            children: heading
          })]
        }, "tabHeading".concat(i));
      })
    })
  });
};
export default TabsHeader;